import { notifyGlobalError } from './notify';

export function handleGlobalErrors (response) {
    // Case of errors
    if (response.data.errors && response.data.errors.nonFieldErrors) {
      notifyGlobalError(response.data.errors.nonFieldErrors[0])
    }
}
